<template>
  <div>
    <b-card v-if="!error && detalle && isObject(detalle)">
      <b-row align-v="center">
        <!-- IMAGEN -->
        <b-col
          cols="12"
          xl="6"
          md="12"
        >
          <b-skeleton-wrapper :loading="setLoader">
            <!-- Loader -->
            <template #loading>
              <b-skeleton-img />
            </template>
            <b-img
              src="https://www.indetec.gob.mx/assets/img/banner_index/banner1.jpg"
              blank-color="#ccc"
              fluid
              alt="Imagen de especialidad"
            />
          </b-skeleton-wrapper>
        </b-col>

        <!-- NAME, DESCRIPTION, DATE, SUCRIPTION BUTTON AND MORE -->
        <b-col>
          <!-- NOMBRE -->
          <div>
            <b-skeleton-wrapper :loading="setLoader">
              <template #loading>
                <b-skeleton
                  :width="`${Math.floor(Math.random() * (100 - 25 + 1)) + 25}%`"
                  type="button"
                  class="mt-1 mb-1"
                />
              </template>
              <h2 class="mt-1 mb-1">
                {{ detalle.nombre }}
              </h2>
            </b-skeleton-wrapper>
          </div>
          <!-- DESCRIPCIÓN -->
          <div>
            <b-skeleton-wrapper :loading="setLoader">
              <template #loading>
                <b-skeleton
                  :width="`${Math.floor(Math.random() * (100 - 25 + 1)) + 25}%`"
                />
                <b-skeleton
                  :width="`${Math.floor(Math.random() * (100 - 25 + 1)) + 25}%`"
                />
              </template>
              <b-card-text>
                {{ detalle.descripcion }}
              </b-card-text>
            </b-skeleton-wrapper>
          </div>

          <b-row class="mx-0">
            <!-- INFORMACIÓN DE ESPECIALIDAD -->
            <b-col
              md="6"
              class="budget-wrapper"
            >
              <b-skeleton-wrapper :loading="loader.datosContacto">
                <template #loading>
                  <b-media
                    no-body
                    class="mt-1"
                  >
                    <b-media-aside class="mr-1">
                      <b-skeleton
                        width="100%"
                        type="button"
                        class="mt-1 mb-1"
                      />
                    </b-media-aside>

                    <b-media-body>
                      <h6 class="mb-0">
                        <b-skeleton
                          width="100%"
                          type="button"
                          class="mt-1 mb-1"
                        />
                      </h6>
                      <b-skeleton
                        :width="`${Math.floor(Math.random() * (100 - 25 + 1)) + 25}%`"
                        class="mt-1 mb-1"
                      />
                      <b-skeleton
                        :width="`${Math.floor(Math.random() * (100 - 25 + 1)) + 25}%`"
                        class="mt-1 mb-1"
                      />
                    </b-media-body>
                  </b-media>
                </template>
                <div>
                  <b-media
                    v-for="planel in datosPlanel"
                    :key="`plantel-key-${planel.id_plantel}`"
                    no-body
                    class="mt-1"
                  >
                    <b-media-aside class="mr-1">
                      <b-avatar
                        rounded
                        variant="light-primary"
                        size="34"
                      >
                        <feather-icon
                          icon="MapPinIcon"
                          size="18"
                        />
                      </b-avatar>
                    </b-media-aside>
                    <b-media-body>
                      <h6 class="mb-0">
                        <b>{{ planel.nombre_plantel }}</b>
                      </h6>
                      <small>{{ planel.direccion }}</small>
                    </b-media-body>
                  </b-media>

                  <b-media
                    v-for="contacto in detalle.contacto"
                    :key="`dpto-key-${contacto.id}`"
                    no-body
                    class="mt-1"
                  >
                    <b-media-aside class="mr-1">
                      <b-avatar
                        rounded
                        variant="light-primary"
                        size="34"
                      >
                        <feather-icon
                          icon="UsersIcon"
                          size="18"
                        />
                      </b-avatar>
                    </b-media-aside>
                    <b-media-body>
                      <h6 class="mb-0">
                        <b>Contacto</b>
                      </h6>
                      <small>{{ contacto.telefono_cont }}</small><br>
                      <small>Ext. {{ contacto.extension_cont }}</small><br>
                      <small>{{ contacto.email_cont }}</small><br>
                      <small>{{ contacto.horario_cont }}</small>
                    </b-media-body>
                  </b-media>
                </div>
              </b-skeleton-wrapper>
            </b-col>

            <!-- SOLICITUD DE ADMISIÓN -->
            <b-col
              md="6"
              class="budget-wrapper"
            >
              <b-card
                :title="!setLoader ? '¿Estás interesado en este programa académico?' : ''"
                class="text-center"
                footer-class="font-weight-bolder"
              >
                <div>
                  <b-skeleton-wrapper :loading="setLoader || loader.checkingSesion">
                    <template #loading>
                      <b-skeleton
                        width="100%"
                        type="button"
                        class="mb-1"
                      />
                      <b-skeleton
                        width="100%"
                        type="button"
                      />
                    </template>
                    <div>
                      <b-alert
                        variant="primary"
                        show
                      >
                        <div class="alert-body">
                          <span>Cupo limitado</span>
                        </div>
                      </b-alert>
                      <b-button
                        v-if="isRegisterAvailable || isRegisterAvailableSpecial"
                        variant="primary"
                        block
                        :to="'/registro/pre-registro/' + detalle.id"
                      >
                        Solicitud de admisión
                      </b-button>
                      <b-alert
                        v-else
                        variant="danger"
                        show
                      >
                        <div class="alert-body">
                          <span>Registro cerrado, revisa las próximas fechas de inscripción.</span>
                        </div>
                      </b-alert>
                    </div>
                  </b-skeleton-wrapper>
                </div>
              </b-card>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>
    <!-- IF WE HAVE AN ERROR -->
    <section v-else>
      <b-alert
        class="text-center"
        variant="danger"
        show
      >
        <h4 class="alert-heading">
          Error cargando contenido
        </h4>
        <div class="alert-body">
          <span>Lo sentimos, no fue posible encontrar información del plan de estudios.</span>
        </div>
      </b-alert>
    </section>
  </div>
</template>

<script>
import {
  BRow, BCol, BCard, BImg, BCardText, BMedia, BMediaAside, BAvatar, BMediaBody, BButton, BAlert,
  BSkeletonWrapper,
  BSkeleton,
  BSkeletonImg,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { getData } from '@core/utils/http/general'
import { rolesActions } from '@core/mixins/account-data/roles'
import { mailConstructor, isObject, isEmptyObject } from '@core/utils/utils'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BImg,
    BCardText,
    BMedia,
    BMediaAside,
    BAvatar,
    BMediaBody,
    BButton,
    BAlert,
    BSkeletonWrapper,
    BSkeleton,
    BSkeletonImg,
  },
  mixins: [rolesActions],
  props: {
    setLoader: {
      type: Boolean,
      default: false,
    },
    detalle: {
      type: Object,
      default: () => {},
    },
    error: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mailConstructor,
      isObject,
      isEmptyObject,
      isRegisterAvailableSpecial: false,
      datosPlanel: [],
      datosDepartamento: [],
      loader: {
        datosContacto: false,
        checkingSesion: false,
      },
    }
  },
  computed: {
    isRegisterAvailable() {
      if (this.error || !this.detalle.calendario || !this.detalle.calendario.length || !isObject(this.detalle) || isEmptyObject(this.detalle)) return false

      const currentDate = Math.floor(Date.now() / 1000)
      const { fechaIni, fechaFin } = this.detalle.calendario.find(item => item.tipo === parseInt(2, 10))

      if (currentDate >= fechaIni && currentDate <= fechaFin) return true
      return false
    },
  },
  created() {
    this.get_datosContacto()
    if (this.$store.state.cuenta.session.token && this.userRol.id) this.checkSession()
  },
  methods: {
    get_datosContacto() {
      this.loader.datosContacto = true
      getData({ action: 17, plan_estudios: this.$route.params.id })
        .then(response => {
          if (response.status !== 200 || response.data.status !== 200) {
            this.$bvToast.toast(response.data.message, {
              title: `${response.data.status} - Error cargando contenido`,
              variant: 'danger',
              solid: true,
            })
          } else {
            this.datosPlanel = response.data.data.direccion_planteles
            this.datosDepartamento = response.data.data.departamentos
          }

          this.loader.datosContacto = false
        })
        .catch(err => {
          this.loader.datosContacto = false
          this.$bvToast.toast(err, {
            title: 'Error en solicitud [planteles / departamentos]',
            variant: 'danger',
            solid: true,
          })
        })
    },
    checkSession() {
      getData({ action: 30, x: this.userRol.id, t: this.$store.state.cuenta.session.token })
        .then(response => {
          if (response.status === 200 && response.data.status === 200) {
            this.isRegisterAvailableSpecial = true
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message,
                text: `Contenido disponible para ${this.userRol.nombre}`,
                icon: 'UnlockIcon',
                variant: 'warning',
              },
            },
            { timeout: 8000 })
          }
        })
        .catch(err => {
          this.isRegisterAvailableSpecial = false
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Error en solicitud [Revisión de cuenta]',
              text: err,
              icon: 'XIcon',
              variant: 'danger',
            },
          },
          { timeout: 8000 })
        })
    },
  },
}
</script>
